import { SET_ASSETS_PATH } from "../../actions/Environment";

const initialState = {
  assetsUrl: "",
};

const CountrySelector = (state = initialState, action) => {
  switch (action.type) {
    case SET_ASSETS_PATH: {
      return Object.assign({}, state, {
        assetsUrl: action.assetsUrl,
      });
    }
    default: {
      return state;
    }
  }
};

export default CountrySelector;
